// extracted by mini-css-extract-plugin
export var headerCell = "_5q-1";
export var loadingSpinnerContainer = "_5q-4";
export var rowWrapper = "_5q-3";
export var standaloneTable = "_5q-5";
export var table = "_5q-0";
export var white = "_5q-2";